import React from "react";
import PropTypes from "prop-types";

const getInitials = (name) => {
  if (!name) return '';
  const parts = name.split(/[ ,]+/);

  return parts
    .filter(Boolean)
    .map((word) => word[0].toUpperCase())
    .slice(0, 2)
    .join('');
};

const Avatar = ({name, src, size = 35, borderColor, alt}) => {
  const sizeValue = typeof size === 'number' ? `${size}px` : size;
  
  const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: sizeValue,
    height: sizeValue,
    borderRadius: '50%',
    color: 'var(--grey-64)',
    backgroundColor: 'var(--bg-light)',
    fontWeight: 'var(--body-small-weight)',
    fontSize: 'var(--body-small-size)',
    overflow: 'hidden',
    ...(borderColor && {
      border: `2px solid ${borderColor}`,
    }),
  };

  if (src) {
    return (
      <img
        src={src}
        alt={alt || name || 'Avatar'}
        style={{
          width: sizeValue,
          height: sizeValue,
          borderRadius: '50%',
          objectFit: 'cover',
          ...(borderColor && {
            border: `2px solid ${borderColor}`,
          }),
        }}
      />
    );
  }

  if (!name) return null;

  const initials = getInitials(name);

  return (
    <div style={containerStyle}>
      {initials}
    </div>
  );
};

Avatar.propTypes = {
  name: PropTypes.string,
  src: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  borderColor: PropTypes.string,
  alt: PropTypes.string,
};

export default Avatar;
